/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { JobsControllerGetOrgFairnessQueryResponse, JobsControllerGetOrgFairnessQueryParams, JobsControllerGetOrgFairness401, JobsControllerGetOrgFairness403 } from "../../models/jobsController/JobsControllerGetOrgFairness";

function getJobsControllerGetOrgFairnessUrl() {
  const res = { method: 'GET', url: `/api/v1/jobs/org-fairness` as const }  
  return res
}

/**
 * @description Returns PROCESSING/QUEUED counts and best queued priority per organization for one worker pool queue (default chat-job-queue), ordered by fewest running then most queued — the order the worker-monitor claimer uses to pick the next org.
 * @summary Get per-org job fairness snapshot
 * {@link /api/v1/jobs/org-fairness}
 */
export async function jobsControllerGetOrgFairness(params?: JobsControllerGetOrgFairnessQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<JobsControllerGetOrgFairnessQueryResponse, ResponseErrorConfig<JobsControllerGetOrgFairness401 | JobsControllerGetOrgFairness403>, unknown>({ method : "GET", url : getJobsControllerGetOrgFairnessUrl().url.toString(), params, ... requestConfig })  
  return res.data
}